import _ from "lodash";

export default {

  SET_ENTERPRISE_ID (state, payload) {
    state.enterpriseId = payload
  },

  SET_VESSEL_ID (state, payload) {
    state.vesselId = payload
  },

  SET_DOCUMENT_ROOT_PATH (state, payload) {
    state.documentRootPath = payload;
  },

  SET_VESSEL_NAME (state, payload) {
    state.vesselName = payload
  },

  SET_DOCUMENT_SIDEBAR_ACTIVE (state, data) {
    state.isDocumentSidebarActive = data;
  },

  SET_DOCUMENT_SIDEBAR_CLICK_NOT_CLOSE (state, data) {
    state.isDocumentSidebarClickNotClose = data;
  },

  SET_CONTENT_INFO_SIDEBAR_ACTIVE (state, data) {
    state.isContentInfoSidebarActive = data;
  },

  SET_DOCUMENTS (state, payload) {
    state.documents = payload;
    state.displayDocuments = _.cloneDeep(state.documents);
  },

  
  RESET_DOCUMENTS(state) {
    state.documents = {
      files: [],
      folders: []
    };
  },

  SET_MOVE_DIALOG_FOLDERS (state, payload) {
    state.moveDialogFolders = payload;
  },

  SET_FOLDERS (state, payload) {
    state.folders = payload;
  },

  SET_FOLDERS_IS_OPEN (state, payload) {
    payload.isOpen = !payload.isOpen;
  },

  SET_FOLDERS_OPEN (state, payload) {
    payload.isOpen = true;
  },

  SET_CHILD_FOLDERS (state, payload) {
    payload.parent.folders = payload.childFolders
  },

  SET_SELECTED_CONTENT_VIEW_STYLE (state, payload) {
    state.selectedContentViewStyle = payload;
  },

  SET_DOCUMENT_SEARCH_QUERY (state, payload) {
    state.documentSearchQuery = payload;
  },

  SET_DOCUMENT_SEARCH (state, payload) {
    state.documentSearchQuery = payload;
    state.searchDocumentsRange = "all";
    state.isSearching = true;
  },

  RESET_DOCUMENT_SEARCH (state) {
    state.documentSearchQuery = "";
    state.searchDocumentsRange = "current";
    state.isSearching = false;
  },

  SET_CURRENT_PATH (state, payload) {
    state.currentPath = payload;
  },

  PUSH_CURRENT_PATH (state, payload) {
    state.currentPath.push(payload);
  },

  RESET_CURRENT_PATH (state) {
    state.currentPath = [];
  },


  SET_SELECTED_DOCUMENT (state, payload) {
    state.selectedDocument = payload;
  },

  // payload: { 
  //   document: object,
  //   selected: boolean
  // },
  SET_SELECTED_DOCUMENTS (state, payload) {
    payload.document.selected = payload.selected;
    if (!payload.selected) {
      state.selectedDocuments = state.selectedDocuments.filter(item => item !== payload.document);
      return;
    }
    state.selectedDocuments.push(payload.document);
  },

  SET_ALL_DOCUMENTS_SELECTED(state) {
    state.isSelectedAllFile = true;
    state.documents.files.forEach(item => {
      item.selected = true;
      state.selectedDocuments.push(item)
    });
    state.documents.folders.forEach(item => {
      item.selected = true;
      state.selectedDocuments.push(item)
    });
    state.displayDocuments = _.cloneDeep(state.documents);
    
  },

  RESET_SELECTED_DOCUMENTS(state) {
    state.isSelectedAllFile = false;
    state.selectedDocuments = [];

    if("files" in state.documents) {
      state.documents.files.forEach(item => {
        item.selected = false;
      });
    }

    if("folders" in state.documents) {
      state.documents.folders.forEach(item => {
        item.selected = false;
      });
    }
    state.displayDocuments = _.cloneDeep(state.documents);
  },


  SET_SEARCHING (state, data) {
    state.isSearching = data;
  },

  SET_SELECTED_SIDEBAR_ITEM (state, payload) {
    state.selectedSidebarItem = payload;
  },

  SET_SELECTED_SIDEBAR_TEXT (state, payload) {
    state.selectedSidebarText = payload;
  },

  SET_SHOW_FOLDER_LIST (state, data) {
    state.showFolderList = data;
  },

  SET_SEARCH_DOCUMENTS_RANGE (state, payload) {
    state.searchDocumentsRange = payload;
  },

  SET_DOCUMENT_NEW_PATH (state, payload) {
    state.documentNewPath = payload
  },

  SET_SELECTED_MOVE_DIAROG_FOLDER (state, payload) {
    state.selectedMoveDialogFolderPath = payload;
  },

  SET_SHOW_LIST_CARD_PATH (state, payload) {
    state.showListCardPath = payload;
  },

  SET_SORT_KEY(state, payload){
    state.sortKey = payload;
  },
  SET_IS_SORT_ORDER_ASC(state, payload){
    state.isSortOrderAsc = payload;
  },

  SET_STORAGE_STATUS (state, payload) {
    state.storageUsage = payload.usage_capacity;
    state.storageMaxCapacity = payload.maximum_capacity;
  },

  RESET_STATE (state, data) {
    Object.assign(state, data);
  },

}
